/* eslint no-param-reassign: 0 */
import React, { useEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

// NodeList.forEach Polyfill for IE & Edge
if (window.NodeList && !window.NodeList.prototype.forEach) {
  window.NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

const HeightMatchingGroup = ({
  children,
  className,
  selector = '.match-height',
  tagName = 'span',
  onClick,
}) => {
  const containerRef = useRef(null)
  const RootTag = `${tagName}`

  const getMaxHeight = useCallback(
    (els) =>
      Array.prototype.map
        .call(els, (el) => el.offsetHeight)
        .reduce((pre, cur) => Math.max(pre, cur), -Infinity),
    []
  )

  const loadImages = useCallback(() => {
    return new Promise((resolve) => {
      const images = containerRef.current.querySelectorAll('img')
      let loaded = 0

      const handleImage = () => {
        loaded += 1
        if (loaded === images.length) resolve()
      }

      images.forEach((image) => {
        image.onload = handleImage
      })
    })
  }, [])

  const matchHeights = useCallback(() => {
    const els = containerRef.current.querySelectorAll(selector)
    els.forEach((el) => {
      el.style.height = null
    })
    const maxHeight = getMaxHeight(els)
    els.forEach((el) => {
      el.style.height = `${maxHeight}px`
    })
  }, [selector, getMaxHeight])

  const preloadAndRun = useCallback(() => {
    loadImages().then(matchHeights)
    setTimeout(matchHeights, 0)
  }, [loadImages, matchHeights])

  useEffect(() => {
    window.addEventListener('resize', matchHeights)
    preloadAndRun()
    return () => {
      window.removeEventListener('resize', matchHeights)
    }
  }, [preloadAndRun, matchHeights])

  useEffect(() => {
    preloadAndRun()
  }, [children, preloadAndRun])

  return (
    <RootTag className={className} ref={containerRef} onClick={onClick}>
      {children}
    </RootTag>
  )
}

HeightMatchingGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  selector: PropTypes.string,
  tagName: PropTypes.string,
  onClick: PropTypes.func,
}

export default HeightMatchingGroup
